export const SubmissionAgidColumns = [];
